import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

export class CommandListJobs {
  async run(
    limit: number = 5,
    offset: number = 0,
    types?: string[],
    statuses?: string[],
    search?: string,
    parentsOnly?: boolean,
  ) {
    try {
      // type/status are repeated query params (ninja List[str]) — used to find an
      // already-running batch job so a page load can adopt it (MPN-1490).
      const extra = [
        ...(types ?? []).map((t) => `&type=${encodeURIComponent(t)}`),
        ...(statuses ?? []).map((s) => `&status=${encodeURIComponent(s)}`),
      ].join("");

      // One box over engagement, campaign, network, job type, status, job number and
      // batch (MPN-1636). Sent only when set, so an empty box is not a filter.
      const query = search?.trim() ? `&search=${encodeURIComponent(search.trim())}` : "";
      // Only the operation rows -- a 300-file reprocess is one parent (MPN-1892).
      const parents = parentsOnly ? "&parents_only=true" : "";

      const request = await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/?offset=${offset}&limit=${limit}${extra}${query}${parents}`,
        {
          method: "GET",
        }
      );
      return this.deserialize(request);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Job[] {
    const serializer = new JobSerializer();
    return serializer.deserializeList(data);
  }
}
